import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import StatusBadge from "@/components/StatusBadge";
import CoinIcon from "@/components/CoinIcon";
import { Button } from "@/components/ui/button";
import api, { apiErr } from "@/lib/api";
import { formatTRY, formatDate, truncate } from "@/lib/format";

export default function AdminPayments() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/payments").then(({ data }) => setItems(data.payments)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const simulate = async (id) => {
    try { await api.post(`/admin/payments/${id}/simulate`, { status: "confirmed" }); toast.success("Ödeme onaylandı (simülasyon)."); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (!items) return <Spinner />;
  return (
    <div>
      <PageHeader title="Ödemeler" desc="Tüm merchant ödemeleri. Sağlayıcı callback'i preview ortamında ulaşmıyorsa onayı simüle edebilirsiniz." />
      {items.length === 0 ? <EmptyState title="Ödeme yok" /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-border bg-muted/40"><tr className="text-left text-xs text-muted-foreground">
                {["Payment ID", "Merchant", "Tutar", "Coin", "Durum", "Tarih", "İşlem"].map((h) => <th key={h} className="px-4 py-3 font-medium whitespace-nowrap">{h}</th>)}
              </tr></thead>
              <tbody className="divide-y divide-border" data-testid="admin-payments-table">
                {items.map((p) => (
                  <tr key={p.id} className="hover:bg-muted/30">
                    <td className="px-4 py-3 font-mono text-xs">{truncate(p.id, 8)}</td>
                    <td className="px-4 py-3 text-muted-foreground text-xs">{p.merchant_email}</td>
                    <td className="px-4 py-3 font-semibold">{formatTRY(p.amount_try)}</td>
                    <td className="px-4 py-3">{p.coin ? <span className="inline-flex items-center gap-1.5"><CoinIcon symbol={p.coin} size={16} /> {p.coin}</span> : "-"}</td>
                    <td className="px-4 py-3"><StatusBadge status={p.status} /></td>
                    <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{formatDate(p.created_at)}</td>
                    <td className="px-4 py-3">{p.coin && !["confirmed", "expired", "failed"].includes(p.status) && <Button size="sm" variant="outline" className="rounded-full" onClick={() => simulate(p.id)}>Onayla</Button>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
